import React from 'react';
import { object } from 'prop-types';
import ErrorPage from '../ErrorPage/index';
import Loading from '../../atoms/Loading/index';
import SingleContentLayout from '../../templates/SingleContentLayout';
import RecipeDetailLayout from '../../templates/RecipeDetailLayout';
import RecipeDetail from '../../organisms/RecipeDetail';

import { REQUESTING } from '../../../constants';

const RecipeDetailPage = ({ profileReducer,
	recipeDetailReducer,
	...props }) => {
	const {fetchingStates,error,errorMessage} = recipeDetailReducer;
	const aryFetchingStates = Object.values(fetchingStates);

	// searching......
	if (aryFetchingStates.some(val => val === REQUESTING.FETCHING)) {
		return <SingleContentLayout render={() => <Loading />} />;
	}
	if (error) {
		return (<ErrorPage error={error} message={errorMessage}/>);
	}
	return <RecipeDetailLayout
		render={() => <RecipeDetail 
			{...profileReducer} 
			{...recipeDetailReducer}
			{...props}
		/>}
	/>
	; // tbd
};

RecipeDetailPage.propTypes = {
	profileReducer: object,
	recipeDetailReducer: object,
	searchRecipesReducer: object
};

export default RecipeDetailPage;